import { State } from 'interfaces/state'
import { createSelector } from 'reselect'

// bounty.app

export const bountyAppSelector = (state: State) => state.app.bounty

export const isRedemptionFormCompletedSelector = createSelector(
  bountyAppSelector,
  (app) => app.redemption.isCompleted
)

export const rewardItemsAppSelector = createSelector(
  bountyAppSelector,
  (app) => app.reward.items
)

export const rewardsFilterSelector = createSelector(
  rewardItemsAppSelector,
  (items) => items.filter
)

export const rewardDismissingIdSelector = createSelector(
  rewardItemsAppSelector,
  (items) => items.dismissingId
)

export const isRewardModalOpenedSelector = createSelector(
  bountyAppSelector,
  (app) => app.reward.isModalOpened
)

export const rewardModalTypeSelector = createSelector(
  bountyAppSelector,
  (app) => app.reward.modalType
)

export const redemptionStepNumberSelector = createSelector(
  bountyAppSelector,
  (app) => app.redemption.stepNumber
)

// bounty.data

export const bountyDataSelector = (state: State) => state.data.bounty

export const rewardItemsDataSelector = createSelector(
  bountyDataSelector,
  (data) => data.reward.items
)

export const rewardSummarySelector = createSelector(
  bountyDataSelector,
  (data) => data.reward.summary
)

export const rewardsTotalAmountSelector = createSelector(
  rewardSummarySelector,
  (rewardSummary) => rewardSummary ? rewardSummary.rewardsTotalAmount : null
)

export const rewardsInProgressCountSelector = createSelector(
  rewardSummarySelector,
  (rewardSummary) => rewardSummary ? rewardSummary.rewardsInProgressCount : null
)

export const redemptionSelector = createSelector(
  bountyDataSelector,
  (data) => data.redemption
)

export const bountyMetaSelector = createSelector(
  bountyDataSelector,
  (data) => data.meta
)

export const rewardBalanceSelector = createSelector(
  bountyMetaSelector,
  (meta) => meta ? meta.rewardBalance : null
)

export const minRedemptionAmountSelector = createSelector(
  bountyMetaSelector,
  (meta) => meta ? meta.minRedemptionAmount : null
)

export const redemptionAccountSelector = createSelector(
  redemptionSelector,
  (redemption) => redemption.account
)

export const redemptionItemsDataSelector = createSelector(
  bountyDataSelector,
  (state) => state.redemption.items
)

export const redemptionItemsAppSelector = createSelector(
  bountyAppSelector,
  (state) => state.redemption.items
)

export const accomplishmentsSelector = createSelector(
  bountyAppSelector,
  (state) => state.accomplishments
)

export const referralInfoSelector = (state: State) => state.data.bounty.referral

export const usdBalanceSelector = createSelector(
  rewardSummarySelector,
  (rewardSummary) => rewardSummary ? rewardSummary.usdBalance : null
)

export const cryptoBalanceSelector = createSelector(
  rewardSummarySelector,
  (rewardSummary) => rewardSummary ? rewardSummary.cryptoBalance : null
)

export const rewardsBalanceHistorySelector = createSelector(
  rewardSummarySelector,
  (summary) => summary?.trend ?? null
)

export const rewardsLifetimeChartSelector = createSelector(
  rewardSummarySelector,
  (summary) => summary?.lifetime_earnings ?? null
)
